// extracted by mini-css-extract-plugin
export default {"backdrop":"DeactivateModal_backdrop__UEJqX","card":"DeactivateModal_card__Gdq3q","fadeInScale":"DeactivateModal_fadeInScale__6jJLD","actions":"DeactivateModal_actions__wDovO"};